import { handleActions } from 'redux-actions'
import {
  SET_INTEGRAL_DATA
} from '../constants/integralConstant'

function handleTicket (item) {
  return {
    id: item['id'],
    // 券名
    title: item['name'],
    // 积分
    integral: item['integral'],
    // 已兑人数(估摸是)
    sales: item['sales'],
    // 商品编号，兑换券(type1)才有这个属性
    contract: item['contract'],
    // 商品ID // 20231213新增
    productId: item['productId'],
    // 商品图片 // 20231218新增
    productImgUrl: item['productImgUrl'] || item['imgUrl'],
    // 面额
    value: item['ticketValue'],
    // 类型
    type: item['ticketType'],
  }
}

export let integralList = handleActions({
  [SET_INTEGRAL_DATA]: (state, action) => {
    const [userData, listData] = action.payload
    let list = listData['integralTicketGoodsResults'].map(handleTicket)
    return {
      listData: list,
      userData
    }
  }
}, {
  listData: [],
  userData: {}
})
